import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import useMediaQuery from "app/hooks/useMediaQuery";
import { animations } from 'react-animation';

Breadcrumbs.propTypes = {
    items:PropTypes.array,
    active:PropTypes.string
};

/* Example of items props
const items = [
    {
        url:"/quienessomos",
        text:"Quienes Somos"
    },
    {
        url:"/quienessomos/grupofinanciero",
        text:"Grupo CS"
    },
]*/

function Breadcrumbs({items, active, ...props}) {
    const is4K = useMediaQuery("(min-width: 3840px)");
    const isFullHD = useMediaQuery("(min-width: 1920px)");
    const isMidLaptop = useMediaQuery("(min-width: 1366px)");
    const isTablet = useMediaQuery("(min-width:768px)");
    const isIphoneX = useMediaQuery('(min-width: 375px)');
    return (
        <div
            className={`${
                is4K
                ? "ms-5 featContainer4K"
                : isFullHD
                ? "ms-5 featContainerFullHD"
                : isMidLaptop
                ? "ms-5 featContainerMidLaptop"
                : isTablet
                ? "ms-5 featContainerTablet"
                : isIphoneX && "ms-3 featContainerPhone"
            }`} 
            style={is4K ? {width:"100%", paddingLeft: "0px", paddingRight2: "1020px", animation: animations.fadeIn}  : {animation: animations.fadeIn}}
        >
        <Breadcrumb>
            <Breadcrumb.Item href="/">Inicio</Breadcrumb.Item>
            {items.map((itm, index) => {
                return <Breadcrumb.Item key={index} href={itm.url}>{itm.text}</Breadcrumb.Item>
            })}
            <Breadcrumb.Item active>{active}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
    );
}

export default Breadcrumbs;